
export default {
  name: 'BmiCalculator',
  jsonld() {
    return {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [{
        "@type": "Question",
        "name": "Is BMI reliable?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "The truth is no. As mentioned, BMI is not a representative measurement of a person's state of health. In many cases, it can be confusing because it overestimates or underestimates body fat. Therefore, I recommend combining various testing and assessment methods to understand your body best."
        }
      },{
        "@type": "Question",
        "name": "Does BMI change with age?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, depending on age, BMI varies widely. Specifically, from 1 year old to before 4-6 years old, BMI tends to decrease and gradually increase until adulthood."
        }
      },{
        "@type": "Question",
        "name": "Why does my BMI say I'm overweight when I'm not?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Because BMI needs to take into account all other body compositions, you won't be able to know the exact relationship between muscle mass and fat. Athletes are often considered obese based on BMI because they have much thicker and heavier muscles than fat."
        }
      },{
        "@type": "Question",
        "name": "Is BMI better than weight?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "The short answer is yes. BMI is a more useful and accurate measure than weight in assessing overweight. Its calculation includes both weight and body height. Meanwhile, weight only partially reflects body mass index BMI."
        }
      },{
        "@type": "Question",
        "name": "Is it better to have a lower or higher BMI?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "As a general rule, it will be difficult for health to improve at its best when BMI decreases or increases. This BMI is strongly associated with overall health according to the U-shaped curve, and valuable means that BMI that is helpful high or too low reduces life expectancy."
        }
      }]
    };
  },
  data () {
    return {
      data: '',
      form: this.$vform({
        gender: 'male',
        unit: 'metric',
        height_metric: 175,
        weight_metric: 70,
        height_us_feet: 5,
        height_us_inch: 10,
        weight_us: 160,
      })
    }
  },
  methods: {
    onBmiCalculator() {
        this.form.post(`/tool/bmi-calculator`, { progress: false }).then(res => {
          this.data = res.data;
        }).catch(e => {
          console.log(e);
        });
    }
  }
}
